/* eslint-disable*/
import React, { useState, useEffect } from "react";

// component
import Bold from "components/Bold";
import Button from "components/Button";
import Divider from "components/Divider";
import H1 from "components/H1";
import TitleV2 from "components/TitleV2";
import H4 from "components/H4";
// import Dropdown from "components/Dropdown";
import DropdownApplication from "components/DropdownApplication";
import Application from "./Application";
import CompanyDataFirstPage from "./CompanyDataFirstPage";
import CreateApplicationPage from "./CreateApplicationPage";
import EditApplicationPage from "./EditApplicationPage";
import DetailApplicationPage from "./DetailTransactionPage";
import SortBy from "./SortBy";
import SuccessSubmit from "./SuccessSubmit";
import ViewAs from "./ViewAs";
import Wrapper from "./Wrapper";
import DetailApplication from "./DetailApplication";
import FilterTable from "./filter-table";

// library
import { Route, Switch, useHistory } from "react-router-dom";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import ReactPaginate from 'react-paginate';

// services
import userSvc from "services/userSvc";
import authSvc from "services/authSvc";
import channelSvc from "services/channelSvc";
import applicationSvc from "services/applicationSvc";
import { logout } from "_redux/actions/authAction";
// import ModalTnC from "components/ModalTnC";

// const path = "/main/my-application";

// const MyApplicationRoute = () => {
//   return (
//     <Switch>
//       <Route path={`${path}`} component={MyApplicationPage} exact />
//       <Route path={`${path}/company-data-first`} component={CompanyDataFirstPage} exact />
//       <Route path={`${path}/create-application`} component={CreateApplicationPage} exact />
//       <Route path={`${path}/edit-application`} component={EditApplicationPage} exact />
//       <Route path={`${path}/detail-transaction/:id`} component={DetailApplicationPage} exact />
//       <Route path="/404" />
//     </Switch>
//   );
// };

// const BtnCreateApp = styled.div`
//   @media only screen and (max-width: 1024px) {
//     margin-top: 24px;
//     width: 100% !important;
//   }
// `;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 0;
  height: 100%;
  position: relative;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 20%;
`;

const LoadingPage = () => {
  const _renderLoading = () => {
    const loadingTemplate = [];
    for (let i = 0; i < 7; i++) {
      loadingTemplate.push(
        <div key={i} className="spinner-grow text-dark" style={{ margin: "10px" }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      );
    }
    return loadingTemplate;
  };

  return <LoadingContainer>{_renderLoading()}</LoadingContainer>;
};

const MyApplicationPage = () => {
  const history = useHistory();
  const dataUser = authSvc.currentUser();
  const dispatch = useDispatch();
  const [showDetail, setShowDetail] = useState(false);
  const [showDetailId, setShowDetailId] = useState("");
  const [successSubmit, setSuccessSubmit] = useState(false);
  const [isEmpty, setIsEmpty] = useState(true);
  const [selectedSortBy, setSelectedSortBy] = useState({
    name: "Latest Update",
    value: { id: "created_at", desc: true },
  });
  const [selectedChannel, setSelectedChannel] = useState({
    name: "All Channel",
    value: { id: -1 }
  });
  const [channelData, setChannelData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isPagination, setPagination]=useState({});
  const [isSearch, setSearch] = useState('');
  const [timer, setTimer] = useState(null)
  const [isUpdatedChange, setUpdatedChange] = useState(false);
  const [finalData, setFinalData] = useState([]);
  // const [isDataApplication, setDataApplication] = useState(null);
  const [filter, setFilter] = useState (
    {
      "user_id": dataUser?.user?.id,
      "start_date": "",
      "end_date": "",
      "channel_id": [],
      "search": isSearch,
      "page": 1,
      "limit": 10
    }
  )
  const SortByData = [
    {
      name: "Latest Update",
      value: { id: "created_at", desc: true },
    },
    {
      name: "Name ( A to Z )",
      value: { id: "application_name", asc: true },
    },
    {
      name: "Name ( Z to A )",
      value: { id: "application_name", desc: true },
    },
  ];
  // const [isModalAddTnC, setModalAddTnC] = useState({show: false});

  useEffect(()=>{
    delayedQuery();
  },[isUpdatedChange])

  useEffect(()=>{
    getAllDataApplication();
  },[isUpdatedChange])

  // Integration
  // useEffect(() => {
  //   async function getDataTnCById(id){
  //     setLoading(true);
  //     try {
  //       const params = {
  //         check: true,
  //         pp_version: '1.9',
  //         tnc_version: '1.2.0'
  //       }
       
  //       const aggrementTnCData = await userSvc.checkAggrementTnC(id, params);
  //       // console.log('aggrementTnCData', aggrementTnCData)
  //       if(!aggrementTnCData?.data?.data?.tnc_accept) {
  //         setTimeout(() => {
  //           setModalAddTnC({show: true})
  //         }, 3000);
  //       }
  //       setLoading(false);
  //     } catch (err) {
  //       setLoading(false);
  //     }
  //   };
  //   getDataTnCById(dataUser?.user?.id);
  // }, [dataUser?.user?.id]);
  
  useEffect(() => {
    const urlParams = window.location.href;
    if(urlParams.includes("staging") || urlParams.includes("qa-") || urlParams.includes("localhost")){
      localStorage.setItem('current_set', 'staging')
      console.log('log login')
    }
    (async () => {
      // setLoading(true);
      const currentUser = authSvc.currentUser();
      if (!currentUser) {
        history.push("/auth/login");
        return;
      }
      const userData = await userSvc.get(currentUser?.user?.id);
      if (!userData?.data?.data?.organization) {
        history.push(`${path}/company-data-first`);
        return;
      }
      loadData();
    })();
  }, []);

  const loadData = async () => {
    try {
      const dataChannel = await channelSvc.getAll();
      createChannelDropdown(dataChannel.data.data);
      setError("");
    } catch (err) {
      setError(err);
    }
    setLoading(false);
  };

  // useEffect(() => {
  //   getAllDataApplication();
  // }, []);

  async function getAllDataApplication(){
      setLoading(true);
      await applicationSvc.getAllApplication(filter)
      .then(result => {
        setFinalData(result?.data?.data?.data || []);

        let paginate = {
          page : result.data?.data?.page,
          limit : result.data?.data?.limit,
          pages : result.data?.data?.pages,
          total_all : result.data?.data?.total,
         }
     
         setPagination(paginate)
        setLoading(false);
      })
      .catch((error) =>{
        // dispatch(logout());
        // localStorage.removeItem("DATA_FORM");
        // history.push("/auth/login");
        setLoading(false);
      })
  };

  // End Integration

  const createChannelDropdown = (channels) => {
    let channelList = [{ name: "All Channel", value: 'id_channel'}];
    // let channelList = [];
    channels.forEach((channel) => {
      channelList.push({ name: channel.name, value: channel.id });
    });
    setChannelData(channelList);
    // setSelectedChannel(0);
  };

  // if (loading) {
  //   return <LoadingPage />;
  // }

  if (error) {
    return <div>{error?.messages}</div>;
  }

  const delayedQuery = async () => {
      let newFilter=filter;
      newFilter.search=isSearch;
      newFilter.page=1;
      setFilter(newFilter);
      
      clearTimeout(timer)
      
      const newTimer = setTimeout(async() => {
        await getAllDataApplication();
      }, 500)
    
      setTimer(newTimer)
  }

  function handlePageClickPagination(e){
    const selectedPage = e.selected + 1;
    let data = filter;
    data.page = selectedPage;
    setFilter(filter)
    getAllDataApplication();
  }
  
  return (
    <div className="d-flex flex-row w-100">
      <div className="row mx-auto flex-row w-75">
        <Wrapper className="d-flex flex-column overflow-hidden w-100">
          {successSubmit && <SuccessSubmit exit={() => setSuccessSubmit(false)} />}
          <div className="d-flex row justify-content-between align-items-center">
            <div className="d-flex flex-column col-md-6">
            <TitleV2>My Application</TitleV2>
            <p className="fsize-16 fweight-400 cl-neutral300 mb-1">application with our channel services</p>
            </div>
          </div>
            {/* <div className="row d-flex justify-content-between align-items-center">
              <div className="col-md-12">
                <div className="d-flex flex-row align-items-center">
                <FilterTable 
                  isPagination={isPagination} 
                  searchKey={setSearch} 
                  setUpdatedChange={setUpdatedChange} 
                  isUpdatedChange={isUpdatedChange} 
                  channelData={channelData} 
                  isFilter={filter} 
                  setFilter={setFilter}></FilterTable>
                </div>
              </div>
            </div> */}
          <Divider className="margin-bottom-20 margin-top-30" />
          {loading && (<LoadingPage />)}
          {!loading && (
            <Application
            setIsEmpty={(val) => setIsEmpty(val)}
            activeId={showDetailId}
            handleDetail={(val, id) => {
              setShowDetail(val);
              setShowDetailId(id);
            }}
            finalData={finalData}
            loading={loading}
            refresh={getAllDataApplication}
          />
          )}
        </Wrapper>
      </div>
      {/* <DetailApplication
        setShowDetail={(val) => {
          setShowDetail(val);
          setShowDetailId("");
        }}
        showDetailId={showDetailId}
        showDetail={showDetail}
      /> */}

      {/* MODAL TNC */}
      {/* {isModalAddTnC && (
        <ModalTnC isModalAddTnC={isModalAddTnC} setModalAddTnC={setModalAddTnC} />
      )} */}
    </div>
  );
};

export default MyApplicationPage;
